import axios from "../axios";
const END_POINT = "/reports";

const getDoctorFunctionality = (payload) => axios.post(`${END_POINT}/functionality/doctor-functionality`, payload);
const getUnitFunctionality = (payload) => axios.post(`${END_POINT}/functionality/units`, payload);
const cashierIncomes = (payload) => axios.post(`${END_POINT}/functionality/cashier-incomes`, payload);
const getReturns = (payload) => axios.post(`${END_POINT}/functionality/returns`,payload);
const getExcel = (payload) => axios.post(`${END_POINT}/functionality/download-excel-units-report`,payload, {
    responseType: 'blob'
});

export {
    getDoctorFunctionality, cashierIncomes, getReturns, getUnitFunctionality,getExcel
};
